import React, { useEffect, useState } from "react";
import {
  getRaceTopList,
  createRaceTop,
  updateRaceTopStatus,
  deleteRaceTop,
  exportRaceTopExcel,
} from "../../api/raceTopApi";
import "../UserManagement/style.css";
import "../../components/pages/CustomerManagement/CustomerDetailModal.css";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const LIST_RACE_TOP = [
  {
    type_game_id: "egame_mpg_chess",
    product_type_ids: ["EGAME", "MPG", "CHESS"],
  },
  {
    type_game_id: "live_sports_animal",
    product_type_ids: ["LIVE", "SPORTS", "ANIMAL"],
  },
];

const GAME_TYPES = LIST_RACE_TOP.map((item) => ({
  label:
    item.type_game_id === "egame_mpg_chess"
      ? "Egame MPG Chess"
      : "Live Sports Animal",
  value: item.type_game_id,
}));

const SITE = process.env.REACT_APP_SITE || "78win";

const MySwal = withReactContent(Swal);

const TopRacePage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({
    account: "",
    top: "",
    type_game_id: GAME_TYPES[0].value,
    product_type_id: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [searchAccount, setSearchAccount] = useState("");
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
    total: 0,
  });
  const [filterTypeGame, setFilterTypeGame] = useState("");

  const fetchData = async (params = {}) => {
    setLoading(true);
    try {
      const response = await getRaceTopList({
        site: SITE,
        account: searchAccount,
        page: pagination.page,
        pageSize: pagination.pageSize,
        type_game_id: filterTypeGame || undefined,
        ...params,
      });
      setData(response.result || []);
      setPagination((prev) => ({ ...prev, total: response.total || 0 }));
    } catch (err) {
      setError("Lỗi khi tải dữ liệu Đua top");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [pagination.page, pagination.pageSize]);

  useEffect(() => {
    fetchData({ page: 1 });
    // eslint-disable-next-line
  }, [searchAccount, filterTypeGame]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "type_game_id") {
      setForm((prev) => ({
        ...prev,
        type_game_id: value,
        product_type_id: "", // reset khi đổi loại game
      }));
    } else if (name === "product_type_id") {
      setForm((prev) => ({ ...prev, product_type_id: value }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      const payload = {
        ...form,
        site: SITE,
        top: Number(form.top),
      };
      await createRaceTop(payload);
      setShowModal(false);
      setForm({
        account: "",
        top: "",
        type_game_id: GAME_TYPES[0].value,
        product_type_id: "",
      });
      fetchData();
    } catch (err) {
      setError("Lỗi khi thêm mới đua top");
    } finally {
      setSubmitting(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setForm({
      account: "",
      top: "",
      type_game_id: GAME_TYPES[0].value,
      product_type_id: "",
    });
    setError(null);
    setSubmitting(false);
  };

  const handleUpdateStatus = (item) => {
    MySwal.fire({
      title: "Xác nhận",
      text: `Bạn có chắc muốn thay đổi trạng thái của tài khoản \"${item.account}\"?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Đồng ý",
      cancelButtonText: "Hủy",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await updateRaceTopStatus(item._id);
          setData((prev) =>
            prev.map((row) =>
              row._id === item._id ? { ...row, status: !row.status } : row
            )
          );
          MySwal.fire("Thành công!", "Trạng thái đã được cập nhật.", "success");
        } catch (err) {
          MySwal.fire("Lỗi!", "Cập nhật trạng thái thất bại.", "error");
        }
      }
    });
  };

  const handleDelete = (account) => {
    MySwal.fire({
      title: "Bạn có chắc không?",
      text: `Bạn sẽ không thể hoàn tác hành động này! Tài khoản \"${account}\" sẽ bị xóa vĩnh viễn.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Đồng ý",
      cancelButtonText: "Hủy",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deleteRaceTop(account);
          setData((prev) => prev.filter((row) => row.account !== account));
          MySwal.fire(
            "Đã xóa!",
            "Tài khoản đã được xóa thành công.",
            "success"
          );
        } catch (err) {
          MySwal.fire("Lỗi!", "Xóa tài khoản thất bại.", "error");
        }
      }
    });
  };

  const handleExportExcel = async () => {
    try {
      const res = await exportRaceTopExcel(SITE);
      const url = window.URL.createObjectURL(new Blob([res]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `race-top-${SITE}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      MySwal.fire("Lỗi!", "Xuất file Excel thất bại.", "error");
    }
  };

  const handleSearch = (e) => {
    setSearchAccount(e.target.value);
    setPagination((prev) => ({ ...prev, page: 1 }));
  };

  return (
    <>
      <div className="users-header">
        <div className="header-content">
          <h3>Quản lý tài khoản</h3>
        </div>
        <div
          className="header-actions"
          style={{ display: "flex", gap: 12, alignItems: "center" }}
        >
          <button
            className="add-user-button"
            onClick={() => setShowModal(true)}
          >
            Thêm mới
          </button>
          <button
            className="add-user-button"
            style={{ background: "#28a745" }}
            onClick={handleExportExcel}
          >
            Xuất File
          </button>
        </div>
      </div>
      <div className="users-controls" style={{ display: "flex", gap: 16 }}>
        <div className="search-container">
          <input
            type="text"
            placeholder="Tìm theo tài khoản..."
            value={searchAccount}
            onChange={handleSearch}
            className="search-input"
          />
        </div>
        <select
          className="filter-select"
          value={filterTypeGame}
          onChange={(e) => setFilterTypeGame(e.target.value)}
        >
          <option value="">Tất cả</option>
          {GAME_TYPES.map((g) => (
            <option key={g.value} value={g.value}>
              {g.label}
            </option>
          ))}
        </select>
      </div>
      {showModal && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Thêm mới Đua top</h2>
              <button className="close-button" onClick={handleCloseModal}>
                ✕
              </button>
            </div>
            <form onSubmit={handleSubmit} className="modal-form">
              <div className="form-group">
                <label>Tài khoản</label>
                <input
                  name="account"
                  value={form.account}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Top</label>
                <input
                  name="top"
                  type="number"
                  value={form.top}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Loại</label>
                <select
                  name="type_game_id"
                  value={form.type_game_id}
                  onChange={handleInputChange}
                  required
                >
                  {GAME_TYPES.map((g) => (
                    <option key={g.value} value={g.value}>
                      {g.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label style={{ marginBottom: 8 }}>Sảnh</label>
                <div style={{ display: "flex", gap: 24 }}>
                  {LIST_RACE_TOP.find(
                    (item) => item.type_game_id === form.type_game_id
                  )?.product_type_ids.map((pt) => (
                    <label
                      key={pt}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                        fontWeight: 500,
                      }}
                    >
                      <input
                        type="radio"
                        name="product_type_id"
                        value={pt}
                        checked={form.product_type_id === pt}
                        onChange={handleInputChange}
                        required
                        style={{ marginRight: 4 }}
                      />
                      {pt}
                    </label>
                  ))}
                </div>
              </div>
              {error && (
                <div style={{ color: "red", marginTop: 8 }}>{error}</div>
              )}
              <div className="modal-actions">
                <button
                  type="button"
                  className="cancel-button"
                  onClick={handleCloseModal}
                  disabled={submitting}
                >
                  Hủy
                </button>
                <button
                  type="submit"
                  className="submit-button"
                  disabled={submitting}
                >
                  {submitting ? "Đang thêm..." : "Thêm mới"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {loading ? (
        <div>Đang tải...</div>
      ) : error ? (
        <div style={{ color: "red" }}>{error}</div>
      ) : (
        <>
          <table className="users-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Ranking</th>
                <th>Loại game</th>
                <th>Sảnh</th>
                <th>Thao tác</th>
              </tr>
            </thead>
            <tbody>
              {data.length === 0 ? (
                <tr>
                  <td colSpan="6">Không có dữ liệu.</td>
                </tr>
              ) : (
                data.map((item, idx) => (
                  <tr key={item._id || idx}>
                    <td>{item.account || "-"}</td>
                    <td>{item.ranking}</td>
                    <td>{item.type_game_id}</td>
                    <td>{item.product_type_id || "-"}</td>
                    <td>
                      {item.type_account === "B" && (
                        <button
                          className="action-btn"
                          title="Xóa"
                          onClick={() => handleDelete(item.account)}
                          style={{ color: "#dc3545", fontSize: 18 }}
                        >
                          🗑️
                        </button>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          <div className="pagination-container">
            <div className="pagination-summary">
              Trang <strong>{pagination.page}</strong> /{" "}
              <strong>
                {Math.ceil(pagination.total / pagination.pageSize)}
              </strong>{" "}
              (Tổng: {pagination.total})
            </div>
            <div className="pagination-controls">
              <button
                onClick={() =>
                  setPagination((p) => ({
                    ...p,
                    page: Math.max(1, p.page - 1),
                  }))
                }
                disabled={pagination.page <= 1}
              >
                Trước
              </button>
              <button
                onClick={() =>
                  setPagination((p) => ({
                    ...p,
                    page: Math.min(
                      Math.ceil(pagination.total / pagination.pageSize),
                      p.page + 1
                    ),
                  }))
                }
                disabled={
                  pagination.page >=
                  Math.ceil(pagination.total / pagination.pageSize)
                }
              >
                Sau
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default TopRacePage;
